import { TAvailableConfigValues } from '@customTypes/common';

export interface IThroughputHistoryConfig {
  ewmaFastAlpha: number;
  ewmaSlowAlpha: number;
  ignorePlaylistsMetrics: boolean;
}

export const defaultThroughputHistoryConfig: IThroughputHistoryConfig = {
  ewmaFastAlpha: 0.9,
  ewmaSlowAlpha: 0.2,
  ignorePlaylistsMetrics: true,
};

export const availableThroughputHistoryConfigValues: TAvailableConfigValues<IThroughputHistoryConfig> = {};
